import { Icon } from '@hai/ui-react';
import React from 'react';

interface OverflowScrollerProps {
  onLeft: () => void;
  onRight: () => void;
  canScrollLeft: boolean;
  canScrollRight: boolean;
  bottomSpacing: number;
}

interface ScrollArrowButtonProps {
  onClick: () => void;
  canScroll: boolean;
  direction: 'left' | 'right';
}

const ScrollArrowButton: React.FunctionComponent<ScrollArrowButtonProps> = ({ onClick, canScroll, direction }) => {
  const isLeft = direction === 'left';
  const icon = true;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Scroll audio meters ${direction}`}
      style={{
        color: '#b9b9b9',
        backgroundColor: 'rgba(0, 0, 0, .65)',
        borderRadius: '4px',
        border: 'none',
        padding: 0,
        pointerEvents: canScroll ? 'auto' : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '56px',
        cursor: canScroll ? 'pointer' : 'default',
        visibility: canScroll ? 'visible' : 'hidden',
      }}
    >
      {icon ? (
        <Icon iconname={isLeft ? 'ArrowThinLeft' : 'ArrowThinRight'} color="haiui-gray-10" size="sm3" />
      ) : (
        <span
          style={{
            width: 0,
            height: 0,
            borderTop: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderRight: isLeft ? '14px solid #9e9e9e' : 'none',
            borderLeft: !isLeft ? '14px solid #9e9e9e' : 'none',
            filter: 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.8))',
          }}
        />
      )}
    </button>
  );
};

export const OverflowScroller = React.forwardRef<HTMLDivElement, OverflowScrollerProps>(
  ({ onLeft, onRight, canScrollLeft, canScrollRight, bottomSpacing }, ref) => (
    <div
      ref={ref}
      className="mk-overflow-scroller"
      style={{
        position: 'absolute',
        left: 1,
        right: 1,
        bottom: 12 + bottomSpacing,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <ScrollArrowButton onClick={onLeft} canScroll={canScrollLeft} direction="left" />
      {canScrollRight && <ScrollArrowButton onClick={onRight} canScroll={canScrollRight} direction="right" />}
    </div>
  ),
);
OverflowScroller.displayName = 'OverflowScroller';
